import { render } from "./WOrganizationCreationForm.vue?vue&type=template&id=d6169434&scoped=true&ts=true"
import script from "./WOrganizationCreationForm.vue?vue&type=script&lang=ts"
export * from "./WOrganizationCreationForm.vue?vue&type=script&lang=ts"

import "./WOrganizationCreationForm.vue?vue&type=style&index=0&id=d6169434&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6169434"]])

export default __exports__